import { render } from "./StatsAppVersion.vue?vue&type=template&id=ab4aaa8c"
import script from "./StatsAppVersion.vue?vue&type=script&lang=js"
export * from "./StatsAppVersion.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fae/dev/grazer/grazer-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__